<div class="h-100 d-flex flex-column">
  <div class="actionBar">
    <div class="flex-grow-1 h-100">
      <input class="search w-100" type="text" placeholder="Search" [formControl]="filterText" />
    </div>
    <button *ngIf="isMonitor == false" (click)="addGateway()" type="button" class="actionBtn" triggers="hover" ngbTooltip="Add New Gateway">
      <span class="bi bi-arrow-left-right"></span>
      <span class="bi bi-plus-circle-fill overlay-icon-plus"></span>

    </button>
  </div>

  <div class="right-side w-100">
    <div class="w-100">
      <div class="jobs">
        <table class="table table-hover table-condensed" style="white-space: nowrap;">
          <thead>
            <tr class="jobHeadRow table-list-head">
              <th scope="col">#</th>
              <th scope="col">
                Name
                <span [ngClass]="
                        sortName == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'
                      " class="bi" (click)="sortByName()"></span>
              </th>
              <th scope="col">
                IP
                <span [ngClass]="
                        sortIP == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'
                      " class="bi" (click)="sortByIP()"></span>
              </th>
              <th scope="col">
                Port
                <span [ngClass]="
                        sortPort == 0 ? 'bi-arrow-down-short' : 'bi-arrow-up-short'
                      " class="bi" (click)="sortByPort()"></span>
              </th>
              <th *ngIf="isMonitor == false" style="text-align: center; max-width: 5%; margin-right: 2%;" scope="col">Actions</th>
            </tr>
          </thead>
          <tbody *ngIf="!dataEmpty">
            <tr class="jobRow table-list-row" *ngFor="let gw of filteredGateways | paginate: { itemsPerPage: itemsPerPage, currentPage: p };
                let i = index" style="cursor: pointer; outline: none;">
              <td scope="row">{{ (p - 1) * itemsPerPage + (i + 1) }}</td>
              <td class="impListName">{{ gw.name }}</td>
              <td>{{ gw.ip }}</td>
              <td>{{ gw.port }}</td>
              <td *ngIf="isMonitor == false" class="controlActions" style="width: 5%; margin-right: 2%;">
                <button type="button" class="connect-button" (click)="gatewayAction('Update', gw)">
                  <span title="Update Gateway" class="bi bi-pencil-square"></span>
                </button>
                <button type="button" class="connect-button" (click)="gatewayAction('Delete', gw)">
                  <span title="Delete Gateway" class="bi bi-trash text-danger"></span>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>  
    </div>      
  </div>

  
  <pagination-controls *ngIf="gateways" class="my-pagination ms-auto" (pageChange)="p = $event"></pagination-controls>
  <p *ngIf="dataEmpty" style="text-align: center; margin-top: 5%;">No Deployment Available.</p>
  <ngx-spinner bdColor="rgba(0,0,0,0)" size="default" zIndex="1" color="var(--s-primary-color)" type="ball-spin"
    [fullScreen]="false">
    <p class="pleaseWait">Please wait...</p>
  </ngx-spinner>
</div>
